import { gql } from '@apollo/client'

export const DELETE_AUDIT = gql`
  mutation DeleteAudit($auditId: ID!) {
    deleteAudit(auditId: $auditId) {
      deleted
    }
  }
`
